import React from "react";
import { Link } from "react-router-dom";
// reactstrap components
import {
  Collapse,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  NavbarBrand,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Container,
  UncontrolledTooltip,
} from "reactstrap";

function LandingNavbar({ token, logout, onPage,isAdmin }) {
  const [navbarColor, setNavbarColor] = React.useState("navbar-transparent");
  const [collapseOpen, setCollapseOpen] = React.useState(false);
  React.useEffect(() => {
    const updateNavbarColor = () => {
      if (
        document.documentElement.scrollTop > 399 ||
        document.body.scrollTop > 399
      ) {
        setNavbarColor("");
      } else if (
        document.documentElement.scrollTop < 400 ||
        document.body.scrollTop < 400
      ) {
        setNavbarColor("navbar-transparent");
      }
    };
    window.addEventListener("scroll", updateNavbarColor);
    return function cleanup() {
      window.removeEventListener("scroll", updateNavbarColor);
    };
  });
  return (
    <>
      {collapseOpen ? (
        <div
          id="bodyClick"
          onClick={() => {
            document.documentElement.classList.toggle("nav-open");
            setCollapseOpen(false);
          }}
        />
      ) : null}
      <Navbar className={"fixed-top " + navbarColor} color="info" expand="lg">
        <Container>
          <UncontrolledDropdown className="button-dropdown">
            <DropdownToggle
              caret
              data-toggle="dropdown"
              href="#pablo"
              id="navbarDropdown"
              tag="a"
              onClick={(e) => e.preventDefault()}
            >
              <span className="button-bar"></span>
              <span className="button-bar"></span>
              <span className="button-bar"></span>
            </DropdownToggle>
            <DropdownMenu aria-labelledby="navbarDropdown">
              <DropdownItem header tag="a">
                เมนู
              </DropdownItem>
              <DropdownItem href="#landing-page" >
                หน้าหลัก
              </DropdownItem>
              <DropdownItem href="#counselling-room-page" >
                ห้องให้การปรึกษา/Walk-in
              </DropdownItem>
              {!token ?
                <DropdownItem href="#login-page" >
                  เข้าใช้งานระบบ
              </DropdownItem>
                :
                <DropdownItem onClick={() => logout()} >
                  ออกจากระบบ
              </DropdownItem>}
            </DropdownMenu>
          </UncontrolledDropdown>
          <div className="navbar-translate">
            <NavbarBrand
              href="#landing-page"
              target=""
              id="navbar-brand"
            >
              MSU CHAT
            </NavbarBrand>
            <UncontrolledTooltip target="#navbar-brand">
              Designed by  <a
              href="https://about.me/khanitin.jornkokgoud"
              target="_blank"
            >
              Khanitin jornkokgoud
            </a>. Coded by MSU-CHAT
            </UncontrolledTooltip>
            <button
              className="navbar-toggler navbar-toggler"
              onClick={() => {
                document.documentElement.classList.toggle("nav-open");
                setCollapseOpen(!collapseOpen);
              }}
              aria-expanded={collapseOpen}
              type="button"
            >
              <span className="navbar-toggler-bar top-bar"></span>
              <span className="navbar-toggler-bar middle-bar"></span>
              <span className="navbar-toggler-bar bottom-bar"></span>
            </button>
          </div>
          <Collapse
            className="justify-content-end"
            isOpen={collapseOpen}
            navbar
          >
            <Nav navbar>
              {/* <NavItem>
                <NavLink to="/index" tag={Link}>
                  Back to Kit
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink href="https://github.com/creativetimofficial/now-ui-kit-react/issues?ref=creativetim">
                  Have an issue?
                </NavLink>
              </NavItem> */}
              {onPage !== 'login' && <NavItem>
                {!token ? <NavLink
                  href="#login-page"
                  id="login-tooltip"
                >
                 
                  <p className="">LOGIN | เข้าใช้งานระบบ</p>
                </NavLink>
                  :
                  <NavLink
                    id="login-tooltip"
                    onClick={() => logout()}
                  >
                    
                    <p className="">LOGOUT | ออกจากระบบ</p>
                  </NavLink>
                 
                  }
                {!token  ?
                  <UncontrolledTooltip target="#login-tooltip">
                    LOGIN | เข้าใช้งานระบบ
                </UncontrolledTooltip>
                  :
                  
                 
                  <UncontrolledTooltip target="#login-tooltip">
                      LOGOUT | ออกจากระบบ
                  </UncontrolledTooltip>
                }
              </NavItem>}

              {onPage !== 'login' && isAdmin && <NavItem>
                {token && isAdmin && 
                  <NavLink
                  href="#profile-page"
                  id="profile-tooltip"
                >
                    
                    <p className="">จัดการข้อมูล</p>
                  </NavLink>
                 
                  }
                {token && isAdmin
                  &&
                  <UncontrolledTooltip target="#profile-tooltip">
                      จัดการข้อมูล
                  </UncontrolledTooltip>
                }
              </NavItem>}

              {onPage !== 'login' && !isAdmin && <NavItem>
                {token && !isAdmin && 
                  <NavLink
                  href="#user-page"
                  id="user-tooltip"
                >
                    
                    <p className="">รายการนัดหมาย</p>
                  </NavLink>
                 
                  }
                {token && !isAdmin
                  &&
                  <UncontrolledTooltip target="#user-tooltip">
                      รายการนัดหมาย
                  </UncontrolledTooltip>
                }
              </NavItem>}


              {onPage !== 'login' && <NavItem>
                {token &&
                  <NavLink
                  href="#change-password-page"
                  id="change-password-tooltip"
                >
                    
                    <p className="">เปลี่ยนรหัสผ่าน</p>
                  </NavLink>
                 
                  }
                {token
                  &&
                  <UncontrolledTooltip target="#change-password-tooltip">
                      เปลี่ยนรหัสผ่าน
                  </UncontrolledTooltip>
                }
              </NavItem>}
            </Nav>
          </Collapse>
        </Container>
      </Navbar>
    </>
  );
}

export default LandingNavbar;
